import { animate, createTimeline, random, remove, stagger } from "animejs";

export type WMUAnimeTargets = Parameters<typeof animate>[0];
export type WMUAnimeParams = Parameters<typeof animate>[1] & {
  targets: WMUAnimeTargets;
};

export type WMUAnimeTimeline = ReturnType<typeof createTimeline>;
export type WMUAnimeAPI = {
  animate: (params: WMUAnimeParams) => ReturnType<typeof animate>;
  timeline: (params?: Parameters<typeof createTimeline>[0]) => WMUAnimeTimeline;
  stagger: typeof stagger;
  random: typeof random;
  remove: typeof remove;
};

const api: WMUAnimeAPI = {
  animate(params) {
    const { targets, ...options } = params;
    return animate(targets, options);
  },
  timeline(params) {
    return createTimeline(params);
  },
  stagger,
  random,
  remove,
};

window.WMUAnime = api;
